import { createReducer, on } from '@ngrx/store';
import * as RuleTypesActions from '../actions/rule-types-actions';
import { iRuleTypesState, RuleTypeData } from '@app/Shared/interfaces/iRuleTypes';

export const initialRuleTypesState: iRuleTypesState = {
    ruleTypes: [],
    selectedRuleType: null,
    isLoading: false,
    error: null,
};

export const ruleTypesReducer = createReducer(
    initialRuleTypesState,

    // Load Rule Types
    on(RuleTypesActions.loadRuleTypes, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RuleTypesActions.loadRuleTypesSuccess, (state, { ruleTypes }) => ({
        ...state,
        ruleTypes,
        isLoading: false,
        error: null,
    })),

    on(RuleTypesActions.loadRuleTypesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Create Rule Type
    on(RuleTypesActions.createRuleType, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RuleTypesActions.createRuleTypeSuccess, (state, { ruleType }) => ({
        ...state,
        ruleTypes: [...state.ruleTypes, ruleType],
        isLoading: false,
        error: null,
    })),

    on(RuleTypesActions.createRuleTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),
// Update Rule Type
    on(RuleTypesActions.updateRuleType, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RuleTypesActions.updateRuleTypeSuccess, (state, { ruleType }) => ({
        ...state,
        ruleTypes: state.ruleTypes.map((r) => (r.DataFieldRuleTypeKey === ruleType.DataFieldRuleTypeKey ? ruleType : r)),
        selectedRuleType: state.selectedRuleType?.DataFieldRuleTypeKey === ruleType.DataFieldRuleTypeKey ? ruleType : state.selectedRuleType,
        isLoading: false,
        error: null,
    })),

    on(RuleTypesActions.updateRuleTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Delete Rule Type
    on(RuleTypesActions.deleteRuleType, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(RuleTypesActions.deleteRuleTypeSuccess, (state, { key }) => ({
        ...state,
        ruleTypes: state.ruleTypes.filter((r) => r.DataFieldRuleTypeKey !== key),
        selectedRuleType: state.selectedRuleType?.DataFieldRuleTypeKey === key ? null : state.selectedRuleType,
        isLoading: false,
        error: null,
    })),
on(RuleTypesActions.deleteRuleTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Select Rule Type
    on(RuleTypesActions.selectRuleType, (state, { ruleType }) => ({
        ...state,
        selectedRuleType: ruleType,
    })),

    on(RuleTypesActions.clearSelectedRuleType, (state) => ({
        ...state,
        selectedRuleType: null,
    }))
);
